var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getBundle)?_c('div',{staticClass:"pa-1 caption orange--text",staticStyle:{"border-radius":"5px","display":"inline-block"},style:({
    'background-color': _vm.colors.orange.lighten5,
    border: ("1px solid " + (_vm.colors.orange.base))
  })},[_vm._v("\n  "+_vm._s(("ซื้อ " + (_vm.getBundle.quantity_condition) + " ชิ้น ลด " + (_vm.getBundle.discount) + " บาท"))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }